import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, BarChart3, Eye, Users } from "lucide-react";

import setAuthToken from "../../../utils/setAuthToken";
import { Spinner, LineChart } from "../../../design-system";

function formatNumber(n) {
  if (n == null) return "—";
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`.replace(".0k", "k");
  return String(n);
}

function formatDateShort(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
}

class LatestAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = { summary: null, loading: true };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      if (token) setAuthToken(token);
      const response = await axios.get("/api/pulse/summary?range=7d");
      this.setState({ summary: response.data, loading: false });
    } catch (error) {
      console.error("Error loading analytics widget:", error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { summary, loading } = this.state;

    return (
      <div className="flex flex-col h-full">
        <header className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="text-sm font-bold tracking-tight">Trafic 7 jours</h3>
          <Link
            to="/dashboard/analytics"
            className="text-xs font-medium text-mute hover:text-text inline-flex items-center gap-1"
          >
            Voir tout <ArrowUpRight className="w-3 h-3" strokeWidth={1.8} />
          </Link>
        </header>
        <div className="flex-1 flex flex-col">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-mute flex-1"><Spinner size="sm" /></div>
          ) : !summary ? (
            <div className="flex flex-col items-center justify-center py-8 text-center text-mute text-sm flex-1">
              <BarChart3 className="w-5 h-5 mb-2 text-mute-2" strokeWidth={1.6} />
              Pas encore de données
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 divide-x divide-border border-b border-border">
                <div className="px-4 py-3">
                  <div className="text-[10.5px] font-mono uppercase tracking-wider text-mute inline-flex items-center gap-1.5 mb-0.5">
                    <Eye className="w-3 h-3" strokeWidth={1.8} />
                    Pages vues
                  </div>
                  <div className="text-2xl font-bold tabular-nums tracking-tight">
                    {formatNumber(summary.totals.views)}
                  </div>
                </div>
                <div className="px-4 py-3">
                  <div className="text-[10.5px] font-mono uppercase tracking-wider text-mute inline-flex items-center gap-1.5 mb-0.5">
                    <Users className="w-3 h-3" strokeWidth={1.8} />
                    Visiteurs
                  </div>
                  <div className="text-2xl font-bold tabular-nums tracking-tight">
                    {formatNumber(summary.totals.uniques)}
                  </div>
                </div>
              </div>

              <div className="px-3 pt-3 pb-1">
                <LineChart
                  data={summary.timeseries || []}
                  xKey="date"
                  height={120}
                  series={[{ key: "views", label: "Vues", color: "ink" }]}
                  formatX={formatDateShort}
                />
              </div>

              {summary.topArticles?.length > 0 && (
                <ul className="border-t border-border divide-y divide-border mt-auto">
                  {summary.topArticles.slice(0, 3).map((a) => (
                    <li key={a.articleId} className="px-4 py-2 flex items-center justify-between gap-3">
                      <Link
                        to={`/dashboard/articles/${a.articleId}/view`}
                        className="text-[12.5px] font-medium text-text hover:underline underline-offset-2 leading-tight line-clamp-1 min-w-0"
                      >
                        {a.title}
                      </Link>
                      <span className="font-mono tabular-nums text-[11.5px] text-mute shrink-0">
                        {formatNumber(a.views)}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default LatestAnalytics;
